export default __webpack_public_path__ + "static/media/leaderboard-bg.db188482.jpg";